<app-select-input [searchable]="true" [formControl]="form" [labelKey]="labelKey" [disabled]="disabled" [options]="options">
  <ng-template let-data="data">
    <ng-container *ngIf="data.value as option">
      <span *ngIf="option.isAdmin"> {{ 'label.admin' | locCap }} </span>
      <span *ngIf="option.resId"> {{ option.resName }} </span>
      <span *ngIf="!option.resId && !option.userId"> {{ 'label.none' | locCap }} </span>
      <span *ngIf="option.userId"> (<mat-icon>person</mat-icon> {{ option.userName }}) </span>
    </ng-container>
  </ng-template>
</app-select-input>
